import { render, staticRenderFns } from "./courseOutline.vue?vue&type=template&id=80838902&scoped=true&"
import script from "./courseOutline.vue?vue&type=script&lang=js&"
export * from "./courseOutline.vue?vue&type=script&lang=js&"
import style0 from "./courseOutline.vue?vue&type=style&index=0&id=80838902&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80838902",
  null
  
)

export default component.exports